import './AccountOnHoldIndicator.scss'
import { memo } from 'react'
import errorIcon from '../../../../images/common/error-icon.svg'
import { accountOnHoldIndicatorsText } from '../../../../pages/charts/patient-chart/Constants'

const AccountOnHoldIndicator = memo(() => (
  <div className='chart-item-account-on-hold-indicator-container'>
    <img src={errorIcon} alt='errorIcon' className='chart-item-account-on-hold-icon' />
    {accountOnHoldIndicatorsText.ACCOUNT_ON_HOLD}
  </div>
))

export default AccountOnHoldIndicator
